import { Dialog, DialogClose, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import React from 'react';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
    label: string;
    text: string;
};

export const ConfirmationModal = ({
    open,
    onConfirm,
    onClose,
    label,
    text,
}: Props) => {
    const handleOpenChange = (state: boolean) => {
        if (!state) onClose();
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent>
                <div className="flex flex-col items-center pt-6 md:p-6 gap-6 w-full overflow-auto">
                    <p className="text-center whitespace-pre-wrap text-neutral-350">
                        {text}
                    </p>
                    <div className="flex flex-col md:flex-row gap-4">
                        <DialogClose>
                            <Button
                                type="button"
                                variant="outline"
                                asChild
                                className="w-full md:w-auto border-neutral-650"
                            >
                                <div>Cancel</div>
                            </Button>
                        </DialogClose>
                        <Button
                            type="button"
                            asChild
                            className="w-full md:w-auto"
                            onClick={onConfirm}
                        >
                            <div>{label}</div>
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
